import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Utensils, MessageCircleWarning } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Moon className="w-8 h-8 text-terracotta" data-id="element-186" />,
    title: 'El horario de dormir',
    description: '¿Quién se levanta esta vez? ¿Lo dejamos llorar un poco o vamos enseguida? La noche se vuelve un campo de batalla silencioso.'
  }, {
    icon: <Utensils className="w-8 h-8 text-terracotta" data-id="element-187" />,
    title: 'La alimentación',
    description: 'Papillas, trozos, horarios... cuando uno quiere seguir una pauta y el otro opina diferente, cada comida es tensión.'
  }, {
    icon: <MessageCircleWarning className="w-8 h-8 text-terracotta" data-id="element-188" />,
    title: '¿Quién hace qué?',
    description: 'La carga mental invisible. Sentir que tienes que pedir ayuda para cosas que deberían ser obvias, desgastando la relación día a día.'
  }];
  return <section className="py-20 px-4 bg-cream relative overflow-hidden" data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-191">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-192">
            Sabemos lo que estás viviendo
          </h2>
          <p className="text-lg text-brown-light leading-relaxed" data-id="element-193">
            Sabemos que la crianza trae amor, pero también choque entre dos
            estilos. No es que no ames a tu pareja, es que cada pequeño detalle
            se vuelve un campo minado de desacuerdos. Y cada día sin resolverlo
            desgasta más la relación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-194">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-blush/20" data-id="element-195">
              <div className="bg-blush/20 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto md:mx-0" data-id="element-196">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-brown mb-3 text-center md:text-left" data-id="element-197">
                {problem.title}
              </h3>
              <p className="text-brown-light leading-relaxed text-center md:text-left" data-id="element-198">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}